import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../links/Link';

function UtilityLinks({ campaignLinks, legalLinks }) {
  return (
    <div className="footer__content">
      <div className="content__links">
        <div className="links__content">
          <ul className="content__primary">
            {campaignLinks.map((link, index) => (
              <li key={index}>
                <Link href={link.href}>{link.text}</Link>
              </li>
            ))}
          </ul>
          <ul>
            {legalLinks.map((link, index) => (
              <li key={index}>
                <Link href={link.href}>{link.text}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

UtilityLinks.propTypes = {
  /**
   * The collection of campaign links
   */
  campaignLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string
    })
  ),
  /**
   * The collection of legal links
   */
  legalLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string
    })
  )
};

export default UtilityLinks;
